import React from 'react';
import { paths } from '@/constants/paths';
import { useTranslations } from 'next-intl';
import { twJoin } from 'tailwind-merge';
import { useCartStore } from '@/ui/store/cart';
import Button from '../../../shared/Button';
import { CartEmptySectionProps } from './types/CartEmptySectionProps';

export function CartEmptySection({ session, isOnCartPage = false }: CartEmptySectionProps) {
  const t = useTranslations('CartEmptySection');
  const { toggleCartDisplay } = useCartStore();

  return (
    <div
      className={twJoin('text-center', isOnCartPage ? ' py-6 md:space-y-6 md:py-6' : 'mt-4 p-2')}
    >
      <p className={twJoin('text-xl font-bold', isOnCartPage && 'sm:text-3xl md:text-5xl')}>
        {t('Your cart is empty')}
      </p>
      {!session && (
        <p
          className={twJoin(
            'mt-2',
            isOnCartPage && 'mx-auto w-2/3 max-w-md sm:text-md md:text-2xl',
          )}
        >
          {t('Sign in to see if you have any saved items Or continue shopping')}
        </p>
      )}
      <div className="mt-4 flex justify-center gap-5">
        <Button
          href={paths.installationCheck}
          onClick={toggleCartDisplay}
          className=" px-4 py-2"
          variant="primary"
        >
          {t('Find your solution')}
        </Button>
        {!session && (
          <Button className=" px-4 py-2" href={paths.login} variant="secondary">
            {t('Sign in')}
          </Button>
        )}
      </div>
    </div>
  );
}
